// Devuelve el número amigable de la orden (order_number si existe, si no, los primeros 8 caracteres del id)
export function getOrderDisplayNumber(order: { order_number?: string, id: string }) {
  if (order.order_number && order.order_number.length > 0) return order.order_number;
  return order.id.slice(0, 8);
}
